import { Component } from '@angular/core';
import { AlertController, LoadingController, NavController, NavParams } from 'ionic-angular';
import { SearchService } from "../../providers/search";
import { SearchresultsPage } from "../searchresults/searchresults";
import { ErrorHandling } from "../../shared/error.handling";
import { TranslateCategoryPipe } from "../../shared/translate-category.pipe";

@Component({
    selector: 'page-last-search-query',
    templateUrl: 'last-search-query.html',
})
export class LastSearchQueryPage {

    lastSearchQueries: any;
    searchResults: any[];

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public searchService: SearchService,
                public errorHandling: ErrorHandling,
                public loadingCtrl: LoadingController,
                public alertCtrl: AlertController) {
    }

    /**
     * Loads last search query
     */
    ionViewDidLoad() {
        this.getLastSearchQueries()
    }

    /**
     * Loads last search query from localStorage
     */
    getLastSearchQueries() {
        let lastQueries = JSON.parse(localStorage.getItem('lastsearch'));
        this.lastSearchQueries = lastQueries.reverse();
    }

    /**
     * Starts last search
     * @param term
     * @param cat
     * @param filter
     */
    startLastSearch(term, cat, filter) {
        let loader = this.loadingCtrl.create();
        loader.present();

        this.searchService.search(term, cat, filter)
            .subscribe(
                (success) => {
                    loader.dismiss();
                    this.searchResults = success.results;

                    if (this.searchResults.length > 0) {
                        this.navCtrl.push(SearchresultsPage, {
                            'resultList': this.searchResults,
                            'resultTotalCount': success.resultTotalCount,
                            'category': cat,
                            'searchTerm': term,
                            'searchFilter': filter
                        });
                    } else {
                        this.presentAlert(cat);
                    }
                },
                (error) => {
                    loader.dismiss();
                    this.errorHandling.handle(error, 'Search');
                }
            );
    }

    /**
     * Creates and shows new alert to user
     * @param cat
     */
    presentAlert(cat) {
        let translateCategoryPipe = new TranslateCategoryPipe();
        let searchCategoryString = translateCategoryPipe.transform(cat);

        let alert = this.alertCtrl.create({
            title: 'Suche ' + searchCategoryString,
            subTitle: 'Keine ' + searchCategoryString + ' gefunden!',
            buttons: ['Ok']
        });
        alert.present();
    }

    /**
     * Clears last search terms from localStorage
     */
    clearSearchIndex() {
        localStorage.setItem('lastsearch', '[]');
        this.lastSearchQueries = [];
    }
}



// WEBPACK FOOTER //
// ./src/pages/last-search-query/last-search-query.ts